import React from 'react';
import { connect } from 'react-redux';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import { push, RouterAction } from 'react-router-redux';
import { LocationDescriptor } from 'history';
import { LinkNavigation } from 'src/types/typings';

let SelectableList = makeSelectable(List);

/**
 * Describes a component route for sidebar navigation
 * Use the optional children array for nested menu items
 */
export interface ComponentRoute {
    path?: string;
    icon: React.ReactElement<any>;
    primaryText: React.ReactNode;
    secondaryText?: string;
    initiallyOpen?: boolean;
    children?: ComponentRoute[];
    disabled?: boolean;
    link?: LinkNavigation;
}

export interface ComponentRoutes extends Array<ComponentRoute> {}

interface MapDispatchToProps {
    push: (nextLocation: LocationDescriptor) => RouterAction;
}

interface OwnProps {
    routes: ComponentRoutes;
}

interface State {
    selectedPath: string;
}

type Props = OwnProps & MapDispatchToProps;

class Navigation extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            selectedPath: window.location.pathname + window.location.search,
        };
    }

    public render() {
        const { routes } = this.props;

        return (
            <SelectableList
                selectedItemStyle={{
                    backgroundColor: '#0a71ba1a',
                }}
                value={this.state.selectedPath}
                onChange={(event: any, index: any) => this.setState({ selectedPath: index })}>
                {routes.map(this.renderListItem)}
            </SelectableList>
        );
    }

    private renderListItem = (componentRoute: ComponentRoute): any => {
        const { push } = this.props;
        const navigationPath = this.getNavigationPath(componentRoute);
        const listItemProps = componentRoute.path ? { value: componentRoute.path } : {};

        return (
            <ListItem
                {...listItemProps}
                disabled={componentRoute.disabled}
                key={componentRoute.path || navigationPath}
                className="styled-list-item"
                primaryText={componentRoute.primaryText}
                secondaryText={componentRoute.secondaryText}
                leftIcon={componentRoute.icon}
                onClick={
                    componentRoute.link
                        ? undefined
                        : navigationPath
                          ? () => this.handleNavigation(navigationPath)
                          : undefined
                }
                target={componentRoute.link ? componentRoute.link.target : undefined}
                href={componentRoute.link ? componentRoute.link.href : undefined}
                initiallyOpen={componentRoute.initiallyOpen === true || this.hasSelectedChild(componentRoute)}
                nestedItems={
                    componentRoute.children && componentRoute.children.length > 0
                        ? componentRoute.children.map(this.renderListItem)
                        : []
                }
            />
        );
    };

    private getNavigationPath = (componentRoute: ComponentRoute): string | undefined => {
        if (componentRoute.path) {
            return componentRoute.path;
        }

        return componentRoute.children && componentRoute.children.length > 0
            ? componentRoute.children[0].path
            : undefined;
    };

    private handleNavigation = (path: string) => {
        this.setState({ selectedPath: path });
        this.props.push(path);
    };

    private hasSelectedChild = (componentRoute: ComponentRoute): boolean => {
        return componentRoute.children
            ? componentRoute.children.some(child => child.path === this.state.selectedPath)
            : false;
    };
}

export default connect<null, MapDispatchToProps, OwnProps>(null, { push })(Navigation);
